// CRM-LEADS-2026-10-16 §4: Settings -> "The app": install the CRM on this device (Android Chrome: Install app / Add to Home
// screen; desktop Chrome or Edge: Install), or see that you are already in it. It opens full-screen with no browser bar,
// and stays signed in for 30 days on this device.
import { useEffect, useState } from 'react';
import { canInstall, onInstallable, promptInstall, isStandalone, DEVICE_DAYS } from './lib/pwa';

const card = { padding: 20, marginBottom: 20 };
const btn = { background: '#0f2744', color: 'white', borderRadius: 8, padding: '0 16px', minHeight: 44, fontSize: 13, fontWeight: 700, border: 0, cursor: 'pointer' };

export default function AppSettings({ standalone = isStandalone(), children = null }) {
  const [installable, setInstallable] = useState(canInstall());
  const [said, setSaid] = useState('');
  useEffect(() => onInstallable(setInstallable), []);
  const install = async () => {
    const r = await promptInstall();
    setSaid(r === 'accepted' ? 'Installed. Open TherapyLink from your home screen or app list.' : r === 'dismissed' ? 'Not installed. You can install it any time from here.' : '');
  };
  return (
    <div className="card" data-testid="app-settings" style={card}>
      <h4 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', margin: '0 0 8px' }}>📱 The app</h4>
      {standalone ? (
        <p data-testid="app-installed" style={{ fontSize: 13, color: '#166534', margin: 0 }}>
          You're using the installed app. It stays signed in for {DEVICE_DAYS} days on this device.</p>
      ) : (
        <>
          <p style={{ fontSize: 13, color: '#334155', margin: '0 0 10px' }}>
            Install TherapyLink on this phone or computer: it opens full-screen like an app, with no browser bar, and stays signed
            in for {DEVICE_DAYS} days on this device. A new device still asks you to sign in.</p>
          {installable ? (
            <button className="nb" data-testid="app-install" onClick={install} style={btn}>Install TherapyLink</button>
          ) : (
            <ul data-testid="app-install-howto" style={{ fontSize: 13, color: '#334155', margin: 0, paddingLeft: 18 }}>
              <li><b>Android (Chrome):</b> tap the ⋮ menu, then <b>Install app</b> or <b>Add to Home screen</b>.</li>
              <li><b>Computer (Chrome or Edge):</b> click the install icon at the right end of the address bar, or the ⋮ / … menu, then <b>Install TherapyLink</b>.</li>
            </ul>
          )}
          {said && <p data-testid="app-install-said" role="status" style={{ fontSize: 13, color: '#334155', margin: '8px 0 0' }}>{said}</p>}
        </>
      )}
      {children}
    </div>
  );
}
